import { render, staticRenderFns } from "./AppLayoutHorizontal.vue?vue&type=template&id=229c8583&"
import script from "./AppLayoutHorizontal.vue?vue&type=script&lang=js&"
export * from "./AppLayoutHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports